import React from 'react'
import PropTypes from 'prop-types'
import {
  HeaderParagraph,
  Header2,
  HeaderNumber,
  StyledContainer,
  StyledLinkWrapper,
  StyledExternalLinkWrapper,
  CompletionCircle,
  CompletionCheckmark,
  TagsContainer,
  Tag,
  TagText,
  HeaderTagsContainer,
  MainLayoutContainer,
  ContentWrapper,
} from './component.styles'
import DoneCheckmark from './assets/checkmark-done-green.svg'
import DoneCheckmarkBlue from './assets/checkmark-done-blue.svg'
import { COMPLETED_ALT_TEXT } from './constants'
import {
  TIERED_INTERVENTION_PROGRAM_LIST,
  K5_PROGRAM_TYPE,
} from 'utils/program/types'

const TieredInterventionUnitCard = ({
  title,
  description,
  path,
  isPreviewMode = true,
  markedComplete = false,
  lessonNumber,
  tags = [],
  programType = K5_PROGRAM_TYPE,
}) => {
  const hasPath = typeof path === 'string' && path.trim().length > 0
  const isAbsoluteUrl = /^https?:\/\//i.test(path || '')

  const cardContent = (
    <StyledContainer>
      <MainLayoutContainer>
        {!isPreviewMode && (
          <CompletionCircle
            data-testid="completion-circle"
            markedComplete={markedComplete}
          >
            {markedComplete && (
              <CompletionCheckmark
                alt={COMPLETED_ALT_TEXT}
                src={
                  programType === K5_PROGRAM_TYPE
                    ? DoneCheckmark
                    : DoneCheckmarkBlue
                }
              />
            )}
          </CompletionCircle>
        )}

        <ContentWrapper>
          <HeaderTagsContainer>
            {Number.isInteger(lessonNumber) && (
              <HeaderNumber>{`${lessonNumber}.`}</HeaderNumber>
            )}
            <Header2>{title}</Header2>
            {tags.length > 0 && (
              <TagsContainer>
                {tags.map((tag, index) => (
                  <Tag key={index}>
                    <TagText>{tag}</TagText>
                  </Tag>
                ))}
              </TagsContainer>
            )}
          </HeaderTagsContainer>

          <HeaderParagraph>{description}</HeaderParagraph>
        </ContentWrapper>
      </MainLayoutContainer>
    </StyledContainer>
  )

  if (!hasPath) {
    return cardContent
  }

  if (isAbsoluteUrl) {
    return (
      <StyledExternalLinkWrapper
        href={path}
        rel="noopener noreferrer"
        target="_blank"
      >
        {cardContent}
      </StyledExternalLinkWrapper>
    )
  }

  return <StyledLinkWrapper to={path}>{cardContent}</StyledLinkWrapper>
}

TieredInterventionUnitCard.propTypes = {
  description: PropTypes.string,
  isPreviewMode: PropTypes.bool,
  lessonNumber: PropTypes.number,
  markedComplete: PropTypes.bool,
  path: PropTypes.string,
  programType: PropTypes.oneOf(TIERED_INTERVENTION_PROGRAM_LIST),
  tags: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string,
}

export default TieredInterventionUnitCard
